import { render } from "./OptionForm.vue?vue&type=template&id=288735d2&scoped=true"
import script from "./OptionForm.vue?vue&type=script&lang=js"
export * from "./OptionForm.vue?vue&type=script&lang=js"

import "./OptionForm.vue?vue&type=style&index=0&id=288735d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288735d2"]])

export default __exports__